import { ChangeDetectionStrategy, Component, Input, computed, inject, input } from '@angular/core';

import { BetType } from '@bpos/common';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { BetContextualDataService } from 'packages/sports/common/betslip/modules/betplacement/services/request/bet-contextual-data.service';

import { MyBetsRaceBetType } from '../../../my-bets-base/models/my-bets-response';
import { MyBetsBet, MyBetsBetSlip } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsTextBadgeModel } from '../badges/my-bets-text-badge.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-my-bets-betslip-market-name',
    styleUrl: 'my-bets-betslip-market-name.component.scss',
    template: `
        <div class="mybets-betslip-info_market-name">
            {{ marketName }}
            @if (showTwoUpMarketSignText()) {
                <ms-my-bets-text-badge [badgeKind]="mybetsTextBadgeModel.EarlyPayout" />
            }
        </div>
    `,
    standalone: false,
})
export class MyBetsBetslipMarketNameComponent {
    constructor(private sitecore: Sitecore) {}

    @Input() bet: MyBetsBet;

    betslip = input<MyBetsBetSlip>();
    cashedOut = input(false);
    cancelledBet = input(false);
    private bcdService = inject(BetContextualDataService);
    private bcdSignal = this.bcdService.betContextualDataSignal;

    mybetsTextBadgeModel = MyBetsTextBadgeModel;
    showTwoUpMarketSignText = computed(
        () =>
            this.bcdSignal()
                ?.get(this.betslip()?.betslipId || '')
                ?.some((ep) => ep.optionId === this.bet.optionMarketInfo?.optionId) &&
            !this.cancelledBet() &&
            !this.cashedOut(),
    );

    get marketName(): string {
        if (this.bet.participantInfo) {
            // participant bet.
            switch (this.bet.sportId) {
                case SportConstant.Horses: {
                    return this.bet.betTypeName;
                }
                case SportConstant.Golf: {
                    if (this.bet.participantInfo.betType === MyBetsRaceBetType.EachWay) {
                        return `${this.bet.marketName} ${this.bet.betTypeName}`;
                    } else {
                        return this.bet.marketName;
                    }
                }
                default: {
                    return this.bet.marketName;
                }
            }
        }

        if (this.bet.isPriceBoosted) {
            return `${this.bet.marketName} - ${this.sitecore.event.PriceBoostMarket}`;
        }

        if (
            this.bet.optionMarketInfo &&
            (this.bet.betType === BetType.EachWay ||
                this.bet.betType === BetType.Forecast ||
                this.bet.betType === BetType.Tricast ||
                this.bet.betType === BetType.CombinationForecast ||
                this.bet.betType === BetType.CombinationTricast)
        ) {
            return this.bet.betTypeName;
        }
        return this.bet.marketName;
    }
}
